<template>
  <div>
    <div class="list-area">
      <vertical-list-slider
        :listItems="buttonList"
        :componentStyle="componentStyle"
        :isActiveVue="isActiveVue"
      ></vertical-list-slider>
    </div>
  </div>
</template>

<script>
import VerticalListSlider from "../components/slider/VerticalListSlider.vue";

export default {
  data() {
    return {
      isActiveVue: true,
      componentStyle: {
        width: Number(window.innerWidth) == 1920 ? "312px" : "206px",
        height: Number(window.innerWidth) == 1920 ? "312px" : "206px",
        "margin-top": "-90px",
        left: Number(window.innerWidth) == 1920 ? "176px" : "120px",
      },
      buttonList: [
        {
          seqNo: 0,
          cardType: "BUTTON",
          list: [
            {
              type: "account",
              buttonName: "계정 및 이용권",
            },
            {
              type: "terms",
              buttonName: "약관",
            },
            {
              type: "logout",
              buttonName: "로그아웃",
            },
          ],
        },
      ],
    };
  },

  components: {
    VerticalListSlider,
  },

  created() {
    this.$store.commit("SET_FOCUSED_VIEW", "default");
  },
  activated() {
    this.isActiveVue = true;
  },
  deactivated() {
    this.isActiveVue = false;
  },
};
</script>

<style scoped>
.list-area {
  position: relative;
  margin-top: 54px;
}

</style>